import {PENDO_ID_PREFIX, PENDO_TREEZ_API_KEY} from '../utils/Constants';
import {PingUser} from './auth/ping/types/PingUser';

/** From Pendo, via 'https://app.pendo.io/setup?setupKey=eyJTdWJzY3JpcHRpb25OYW1lIjoiVHJlZXoiLCJIbWFjIjoidlZWVFlCbGtyZ19aTmJoN3ZMbzZzeV9kRE9XUXYwY19La0ZBU3hxdGZQWT0ifQ&os=web':
This script include snippet was essentially included in index.html, making the pendo.* functions available.

<script>
(function(apiKey){
    (function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=o._q||[];
    v=['initialize','identify','updateOptions','pageLoad','track'];for(w=0,x=v.length;w<x;++w)(function(m){
        o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);
        y=e.createElement(n);y.async=!0;y.src='https://cdn.pendo.io/agent/static/'+apiKey+'/pendo.js';
        z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo');
})('717f8af9-6f01-42a1-73f2-c643a5927d2e');
</script>

*/

export interface PendoProps {
    visitorId: string;
    visitorEmail?: string;
    accountId?: string;
}

export const initPendo = ({visitorId, visitorEmail, accountId}: PendoProps): void => {
    if (!globalThis.pendo) {
        return; // Prevent errors if this is called without pendo being loaded
    }
    if (globalThis.pendo.pendoWasInitialized) {
        return; // A simple flag to guard from initializing multiple times
    }

    // This function creates anonymous visitor IDs in Pendo unless you change the visitor id field to use your app's values
    // Call this function in your authentication promise handler or callback when your visitor and account id values are available
    // Please use Strings, Numbers, or Bools for value types.

    globalThis.pendo.initialize({
        visitor: {
            id: `${PENDO_ID_PREFIX}${visitorId}`, // Required if user is logged in, default creates anonymous ID
            email: visitorEmail, // Recommended if using Pendo Feedback, or NPS Email
            // full_name:    // Recommended if using Pendo Feedback
            // role:         // Optional

            // You can add any additional visitor level key-values here,
            // as long as it's not one of the above reserved names.
        },
        account: {
            id: accountId || 'UNKNOWN-ACCOUNT-ID', // Required if using Pendo Feedback, default uses the value 'ACCOUNT-UNIQUE-ID'
            // name:         // Optional
            // is_paying:    // Recommended if using Pendo Feedback
            // monthly_value:// Recommended if using Pendo Feedback
            // planLevel:    // Optional
            // planPrice:    // Optional
            // creationDate: // Optional

            // You can add any additional account level key-values here,
            // as long as it's not one of the above reserved names.
        },
    });

    globalThis.pendo.pendoWasInitialized = true;
};

export const initPendoWithUser = (user: PingUser, orgId?: number): void => {
    if (window.location.hostname === 'localhost') {
        return;
    }

    const organizationId = orgId || user.organizationId;

    const initCallback = (): void => {
        initPendo({
            visitorId: user.id,
            visitorEmail: user.email,
            accountId: `org-${organizationId}`,
        });
    };

    if (globalThis.loadPendoSnippet !== undefined) {
        // Currently defined in index.html
        globalThis.loadPendoSnippet(PENDO_TREEZ_API_KEY, initCallback);
    }
};

export default initPendo;
